import { useState } from 'react';

export default function KPICard({ title, value, subtitle, color = '#41B073', icon, onClick, alert }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: '#1a1d2e',
        border: '1px solid #2a2d3e',
        borderLeft: `4px solid ${color}`,
        borderRadius: 10,
        padding: '18px 20px',
        cursor: onClick ? 'pointer' : 'default',
        transform: hovered && onClick ? 'translateY(-2px)' : 'none',
        transition: 'transform 0.15s, box-shadow 0.15s',
        boxShadow: hovered && onClick ? `0 4px 20px ${color}33` : '0 2px 8px rgba(0,0,0,0.3)',
        position: 'relative',
        minWidth: 0,
      }}
    >
      {alert && (
        <span style={{
          position: 'absolute', top: 12, right: 12,
          width: 10, height: 10, borderRadius: '50%',
          background: '#ef4444',
          boxShadow: '0 0 0 3px #ef444433',
          animation: 'pulse 1.5s infinite',
        }} />
      )}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
        {icon && <span style={{ fontSize: 20 }}>{icon}</span>}
        <span style={{ fontSize: 12, color: '#94a3b8', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.05em' }}>{title}</span>
      </div>
      <div style={{ fontSize: 28, fontWeight: 700, color: '#e2e8f0', lineHeight: 1.1, fontFamily: "'DM Mono', monospace" }}>
        {value}
      </div>
      {subtitle && <div style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>{subtitle}</div>}
      <style>{`@keyframes pulse { 0%,100% { opacity:1 } 50% { opacity:0.4 } }`}</style>
    </div>
  );
}
